import { initializeApp } from "firebase/app";

import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAVTja9s11-Vcm4ZWWEPhrCNxrEJEPNwFc",
  authDomain: "apnathali-42b75.firebaseapp.com",
  projectId: "apnathali-42b75",
  storageBucket: "apnathali-42b75.appspot.com",
  messagingSenderId: "457897045541",
  appId: "1:457897045541:web:23c2f4ef2bbb048da319cc",
  measurementId: "G-W3HK937X8V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);